import React, { Component } from 'react';
import './styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GELogo from '../../Assets/Images/Branding.svg';
import {
  userSidemenuItems,
  profileItem,
  trainerSidemenuItems,
  logoutItem,
} from '../Sidemenu/SidemenuConstants';
import {
  getSubscriptionInfo,
  getSubscription,
} from 'src/Actions/Subscription/subscriptionAction';
import {
  getProfileDetails,
} from 'src/Actions/Profile/profileActions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setMenuItems } from 'src/Utils';
import { signOut } from 'src/authConfig';
import { withTranslation } from 'react-i18next';
import { GE_DOMAIN } from 'src/Config/constants';

let loginType = localStorage.getItem('loginType');
export class HamburgerMenu extends Component {
  constructor(props) {
    super(props);
    let { b, c, adhoc, activeConfigList } = this.props.subscription;
    this.state = {
      sideMenuList:
        loginType === GE_DOMAIN
          ? trainerSidemenuItems
          : setMenuItems(userSidemenuItems, b, c, adhoc, activeConfigList),
      activeItem: null,
      showMenu: false,
    };
  }

  componentDidMount() {
    this.props.getProfileDetails();
    let activeItem = localStorage.getItem('activeItem');
    let { b, c, adhoc, activeConfigList } = this.props.subscription;
    this.setState(
      {
        sideMenuList:
          loginType === GE_DOMAIN
            ? trainerSidemenuItems
            : setMenuItems(userSidemenuItems, b, c, adhoc, activeConfigList),
        activeItem,
      },
      () => {
        if (loginType !== GE_DOMAIN) {
          this.props.getSubscription();
        }
        let { sideMenuList } = this.state;
        sideMenuList.forEach((menu) => {
          menu.status = menu.key === activeItem ? true : false;
        });
        this.setState({
          sideMenuList,
        });
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.showMenu !== this.state.showMenu) {
      this.props.setHamburgerVisibility(this.state.showMenu);
    }
    if (prevProps.subscription !== this.props.subscription) {
      let { b, c, adhoc, activeConfigList } = this.props.subscription;
      this.setState({
        sideMenuList:
          loginType === GE_DOMAIN
            ? trainerSidemenuItems
            : setMenuItems(userSidemenuItems, b, c, adhoc, activeConfigList),
      });
    }
    if(this.state.activeItem !== localStorage.getItem('activeItem'))
    {
      this.setState({activeItem:localStorage.getItem('activeItem')});
    }
  }

  setActiveItem = (item) => {
    localStorage.setItem('activeItem', item.key);
    if (loginType !== GE_DOMAIN) {
      this.props.getSubscriptionInfo();
    }
    this.setState({
      activeItem: item.key,
      showMenu: item.key === 'Account' ? false : !this.state.showMenu,
    });
    this.props.history.push(item.component);
  };

  openMenu = () => {
    let { showMenu } = this.state;
    this.setState({
      showMenu: !showMenu,
    });
  };

  refresh = () => {
    window.location.href = `${window.location.origin}`;
  };

  logoutSession = async () => {
    localStorage.setItem('isAutomaticLogout', false);
    localStorage.removeItem('authLang');
    signOut();
  };
  renderLogout = (arr) => {
    let activeItem = localStorage.getItem('activeItem');
    return arr.map((item, index) => (
      <div
        key={item.key}
        id={item.key}
        className={
          activeItem === item.key
            ? 'ms-Grid-row menu-item menu-item-true hover-hand'
            : 'ms-Grid-row menu-item menu-item-false hover-hand'
        }
        onClick={() => this.logoutSession(item)}
      >
        <img src={item.icon} />
        <div className="title">{item.text}</div>
      </div>
    ));
  }
  getProfileIconDetails = () => {
    let { profileDetails } = this.props.profile;
    let avatarName = '';
    if (profileDetails?.firstName) {
      avatarName = profileDetails?.firstName.charAt(0);
    }
    if (profileDetails?.lastName) {
      avatarName = avatarName + profileDetails?.lastName.charAt(0);
    }
    else {
      avatarName = avatarName + '';
    }
    return avatarName;
  };
  renderIcons = (arr, activeItem) => {
    return arr.map((item, index) => (
      <div
        key={item.key}
        id={item.key}
        className={
          activeItem === item.key
            ? 'ms-Grid-row menu-item menu-item-true hover-hand'
            : 'ms-Grid-row menu-item menu-item-false hover-hand'
        }
        onClick={() => this.setActiveItem(item)}
      >
        {item.key !== 'Account' ?
          <img src={item.icon} />
          : (
            <div className="account-logo">
              <p className="account-initial">
                {this.getProfileIconDetails()}
              </p>
            </div>)}
        <div className="title">{item.text}</div>
      </div>
    ));
  };

  render() {
    const { t } = this.props;
    let darkTheme = localStorage.getItem('darkTheme');
    let { notificationCount } = this.props.subscription;
    let { showMenu, activeItem } = this.state;
    let profileIcon = {
      key: 'Account',
      status: false,
      component: '/account',
      text: t('account')
    };
    
    return (
      <div className={`menu-container-${darkTheme}`}>
        <div className="ms-Grid-row header-wrapper">
          <div className="left-header">
            <div style={{ position: 'absolute' }}>
              <FontAwesomeIcon
                className="hamburger-icon hover-hand"
                icon={showMenu ? 'times' : 'bars'}
                onClick={this.openMenu}
              />
              {!showMenu && notificationCount > 0 ? (
                <div className="badge-container">
                  <span className="badge">{notificationCount}</span>
                </div>
              ) : null}
            </div>
            <div className="ms-Grid-row logo-wrapper">
              <img src={GELogo} onClick={this.refresh} />
              <div className='logo-line'></div>
              <div className="de-text">{t('digitalExpert')}</div>
            </div>
          </div>
          <div id="account-icon-container">
            {!showMenu && notificationCount > 0 ? (
              <div className="badge-container">
                <span className="badge">{notificationCount}</span>
              </div>
            ) : null}
            <div onClick={() => this.setActiveItem(profileIcon)}
              className="account-logo">
              <p className="account-initial">
                {this.getProfileIconDetails()}
              </p>
            </div>
          </div>
        </div>
        <div className={`overlay-${showMenu} overlay`} onClick={this.openMenu}>
          <div className={`menu-drawer-${showMenu} menu-drawer`}>
            {this.renderIcons(this.state.sideMenuList, activeItem)}
            {this.renderIcons(profileItem, activeItem)}
            {this.renderLogout(logoutItem)}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ profile, generic, subscription }) => ({
  profile,
  generic,
  subscription,
});

const mapDispatchToProps = (dispatch) => ({
  getProfileDetails: () => dispatch(getProfileDetails()),
  getSubscriptionInfo: () => dispatch(getSubscriptionInfo()),
  getSubscription: () => dispatch(getSubscription()),
});

export default (withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(HamburgerMenu))
));
